/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUsersAPIKeysIntegratorOptions,
  GetUsersAPIKeysIntegratorStatus200,
  GetUsersAPIKeysIntegratorStatus400,
  GetUsersAPIKeysIntegratorStatus500,
} from '../types/GetUsersAPIKeysIntegrator'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUsersAPIKeysIntegrator } from '../clients/getUsersAPIKeysIntegrator'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersAPIKeysIntegratorQueryKey = ({
  path,
}: Omit<GetUsersAPIKeysIntegratorOptions, 'headers'>) =>
  [{ url: '/v1/user/:user_id/apikey', params: path }] as const

type GetUsersAPIKeysIntegratorQueryKey = ReturnType<typeof getUsersAPIKeysIntegratorQueryKey>

export function getUsersAPIKeysIntegratorQueryOptions(
  { path }: GetUsersAPIKeysIntegratorOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUsersAPIKeysIntegratorQueryKey({ path })
  return queryOptions<
    GetUsersAPIKeysIntegratorStatus200,
    ResponseErrorConfig<GetUsersAPIKeysIntegratorStatus400 | GetUsersAPIKeysIntegratorStatus500>,
    GetUsersAPIKeysIntegratorStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUsersAPIKeysIntegrator({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get user's api keys: admin or integrator only
 * {@link /v1/user/:user_id/apikey}
 */
export function useGetUsersAPIKeysIntegrator<
  TData = GetUsersAPIKeysIntegratorStatus200,
  TQueryData = GetUsersAPIKeysIntegratorStatus200,
  TQueryKey extends QueryKey = GetUsersAPIKeysIntegratorQueryKey,
>(
  {
    path,
  }: {
    path:
      | GetUsersAPIKeysIntegratorOptions['path']
      | (() => GetUsersAPIKeysIntegratorOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUsersAPIKeysIntegratorStatus200,
        ResponseErrorConfig<
          GetUsersAPIKeysIntegratorStatus400 | GetUsersAPIKeysIntegratorStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getUsersAPIKeysIntegratorQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getUsersAPIKeysIntegratorQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetUsersAPIKeysIntegratorStatus400 | GetUsersAPIKeysIntegratorStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
